<div class="cc-status-wait-count-tile-wrapper">
  <p>lobby-status-wait-count-tile works!</p>
</div>
